import * as Types from '../../tenants/kwg/generated';

import { UserSettingFragmentDoc } from './userSettings.fragment.g';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const GetUserSettingsDocument = `
    query GetUserSettings($key: String!) {
  userSetting(key: $key) {
    ...UserSetting
  }
}
    ${UserSettingFragmentDoc}`;

export const useGetUserSettingsQuery = <
      TData = Types.GetUserSettingsQuery,
      TError = unknown
    >(
      variables: Types.GetUserSettingsQueryVariables,
      options?: Omit<UseQueryOptions<Types.GetUserSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.GetUserSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.GetUserSettingsQuery, TError, TData>(
      {
    queryKey: ['GetUserSettings', variables],
    queryFn: fetcher<Types.GetUserSettingsQuery, Types.GetUserSettingsQueryVariables>(GetUserSettingsDocument, variables),
    ...options
  }
    )};

export const useSuspenseGetUserSettingsQuery = <
      TData = Types.GetUserSettingsQuery,
      TError = unknown
    >(
      variables: Types.GetUserSettingsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<Types.GetUserSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<Types.GetUserSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<Types.GetUserSettingsQuery, TError, TData>(
      {
    queryKey: ['GetUserSettings', variables],
    queryFn: fetcher<Types.GetUserSettingsQuery, Types.GetUserSettingsQueryVariables>(GetUserSettingsDocument, variables),
    ...options
  }
    )};

export const useInfiniteGetUserSettingsQuery = <
      TData = InfiniteData<Types.GetUserSettingsQuery>,
      TError = unknown
    >(
      variables: Types.GetUserSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<Types.GetUserSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<Types.GetUserSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<Types.GetUserSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserSettings.infinite', variables],
      queryFn: (metaData) => fetcher<Types.GetUserSettingsQuery, Types.GetUserSettingsQueryVariables>(GetUserSettingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const useSuspenseInfiniteGetUserSettingsQuery = <
      TData = InfiniteData<Types.GetUserSettingsQuery>,
      TError = unknown
    >(
      variables: Types.GetUserSettingsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<Types.GetUserSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<Types.GetUserSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<Types.GetUserSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUserSettings.infinite', variables],
      queryFn: (metaData) => fetcher<Types.GetUserSettingsQuery, Types.GetUserSettingsQueryVariables>(GetUserSettingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};
